module.exports = __webpack_public_path__ + "static/media/coupon-fill.cb92c5d1.svg";